import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  BuyerAccountV1Response,
  PaymentExecutionV1Request,
  PaymentExecutionV1Response,
  PaymentInquiryV1Response,
  PaymentPreviewHostedPaymentV1Request,
  PaymentPreviewHostedPaymentV1Response,
  PaymentPreviewV1Request,
  PaymentPreviewV1Response,
  PayOnAccountPaymentPreviewV1Request,
  PayOnAccountPaymentPreviewV1Response,
  PayOtherAmountV1ApiRequest,
  PayOtherAmountV1Response,
} from '../models';

/* istanbul ignore next */
export abstract class PaymentInformationService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig('paymentInformationServiceUrl');
  }

  public setBaseUrl(url: string) {
    this.baseUrl = url;
  }

  abstract updateHostedPaymentPreviewV1(
    tenantId: string,
    paymentPreviewHostedPaymentV1Request: PaymentPreviewHostedPaymentV1Request,
  ): Observable<PaymentPreviewHostedPaymentV1Response>;

  abstract updatePaymentPreviewV1(
    tenantId: string,
    paymentPreviewV1Request: PaymentPreviewV1Request,
  ): Observable<PaymentPreviewV1Response>;

  abstract getHostedPaymentPreviewV1(
    tenantId: string,
    paymentReference: string,
  ): Observable<PaymentPreviewHostedPaymentV1Response>;

  abstract getPaymentPreviewV1(
    tenantId: string,
    paymentReference: string,
  ): Observable<PaymentPreviewV1Response>;

  abstract getPayOnAccountPaymentPreviewV1(
    tenantId: string,
    paymentReference: string,
  ): Observable<PayOnAccountPaymentPreviewV1Response>;

  abstract executePaymentV1(
    tenantId: string,
    paymentReference: string,
    transactionReference: string,
    paymentExecutionV1Request: PaymentExecutionV1Request,
  ): Observable<PaymentExecutionV1Response>;

  abstract getBuyerAccountsV1(
    tenantId: string,
    externalUserUrn: string,
    originApplication: string,
  ): Observable<BuyerAccountV1Response>;

  abstract GetPayOtherDocuments(
    tenantId: string,
    payOtherAmountV1ApiRequest: PayOtherAmountV1ApiRequest,
  ): Observable<PayOtherAmountV1Response>;

  abstract updatePaymentPreviewPayOnAccountV1(
    tenantId: string,
    payOnAccountPaymentPreviewV1Request: PayOnAccountPaymentPreviewV1Request,
  ): Observable<PayOnAccountPaymentPreviewV1Response>;

  abstract getPaymentByReferenceV1(
    tenant: string,
    paymentReference: string,
  ): Observable<PaymentInquiryV1Response>;
}
